/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest(".product-recommendations--parent");
  }
  fetchProducts() {
    if (this.loading || this.classList.contains("product-recommendations--loaded")) return;
    let url;
    try {
      url = new URL(this.dataset.url, window.location.origin);
    } catch {
      return;
    }
    if (!/^[1-9]\d*$/.test(url.searchParams.get("product_id") || "")) return;
    this.loading = true;
    fetch(url.href)
      .then((response) => {
        if (!response.ok) throw new Error(`Product recommendations: HTTP ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          if (this.parent) {
            this.parent.classList.add("product-recommendations--full");

            if (document.body.classList.contains("open-cart")) {
              this.parent.classList.add("active");
            }
          }
        }

        this.classList.add("product-recommendations--loaded");
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  connectedCallback() {
    this.parent = this.closest(".product-recommendations--parent");
    this.fetchProducts();
  }
}

if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}
